import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/lib/auth";
import { supabase } from "@/integrations/supabase/client";

export function useTeamId() {
  const { user } = useAuth();

  const { data: teamId, isLoading, error } = useQuery({
    queryKey: ["user-team-id", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("users")
        .select("team_id")
        .eq("id", user!.id)
        .single();
      if (error) throw error;
      return data.team_id;
    },
    enabled: !!user,
    staleTime: Infinity,
  });

  return { teamId: teamId ?? null, isLoading, error };
}
